<template>
  <div class="firmElectDetail">
    <div class="firmElect-detail">
      <detail-navigation :activeNav="activeNav" :activeDetailBanner="activeDetailBanner"></detail-navigation>

      <div class="page-nav">
        <page-nav :pageNav='pageNav' @toNode="toModule"></page-nav>
      </div>

      <apply-megagame :megagameApple="megagameApple" :activeNav="activeNav"></apply-megagame>

      <div class="nav-index" id="intro">
        <span class="nav-title">活动简介</span>
        <active-intro :activeInfo="firmElectIntro"></active-intro>
      </div>

      <div class="firmElect-information">
        <div id="notification">
          <span class="nav-title">评选通知</span>
          <notification-message :information="notification" :detailPath="'/informDetail'"></notification-message>
        </div>

        <div id="message">
          <span class="nav-title">相关资讯</span>
          <notification-message :information="message" :detailPath="'/informationDetail'"></notification-message>
        </div>
      </div>

      <div class="nav-index" id="condition">
        <span class="nav-title">参与条件</span>
        <condition :condition="participationCondition"></condition>
      </div>

      <div class="nav-index" id="plan">
        <span class="nav-title">活动安排</span>
        <plan :activityPlan="activities"></plan>
      </div>

      <div class="nav-index" id="organization">
        <span class="nav-title">组织机构</span>
        <detail-organization :organizationUnitsName="organizationUnitsName"
          :organizationUnits='organizationUnits'>
        </detail-organization>
      </div>
    </div>

    <return-top></return-top>

  </div>
</template>

<script>
import DetailNavigation from '@/components/active/particulars/detailNavigation.vue'
import PageNav from '@/components/active/particulars/pageNav.vue'
import ApplyMegagame from '@/components/active/particulars/applyMegagame.vue'
import ActiveIntro from '@/components/active/particulars/activeIntro.vue'
import NotificationMessage from '@/components/active/particulars/notificationMessage.vue'
import Condition from '@/components/active/particulars/condition.vue'
import Plan from '@/components/active/particulars/plan.vue'
import DetailOrganization from '@/components/active/particulars/detailOrganization.vue'
import ReturnTop from '@/components/returnTop.vue'
export default {
  naem: 'firmElectDetail',
  props: {},
  components: {
    DetailNavigation,
    PageNav,
    ApplyMegagame,
    ActiveIntro,
    NotificationMessage,
    Condition,
    Plan,
    DetailOrganization,
    ReturnTop
  },
  data () {
    return {
      activeNav: {
        firstNav: '企业评选',
        firstPath: '/firmElect',
        secondNav: '企业评选详情'
      }, // 详情页面包屑导航
      activeDetailBanner: '', // 详情页banner图
      pageNav: [
        { name: '活动简介', id: 'intro' },
        { name: '参与条件', id: 'condition' },
        { name: '活动安排', id: 'plan' },
        { name: '组织机构', id: 'organization' },
        { name: '评选通知', id: 'notification' },
        { name: '相关资讯', id: 'message' }
      ],
      megagameApple: {}, // 活动报名
      firmElectIntro: '', // 活动简介
      notification: [], // 通知
      message: [], // 资讯
      participationCondition: '', // 参与条件
      activities: [], // 活动安排
      organizationUnitsName: ['指导单位', '主办单位'], // 组织机构名称
      organizationUnits: {}, // 组织机构单位
      specificfirmElectId: '' // 具体某个企业id
    }
  },
  computed: {},
  created () {
    // this.getDetailData()
    this.getMegagameData()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '4'
  },
  methods: {
    // 锚点链接
    toModule (id) {
      if (id === 'intro') {
        document.querySelector('#intro').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'condition') {
        document.querySelector('#condition').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'plan') {
        document.querySelector('#plan').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'organization') {
        document.querySelector('#organization').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'notification') {
        document.querySelector('#notification').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'message') {
        document.querySelector('#message').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },

    // 获取企业评选详情页数据
    // getDetailData () {
    //   const dataDetail = JSON.parse(sessionStorage.getItem('activityDetail'))
    //   this.activeDetailBanner = dataDetail.banner // 大赛横幅
    //   this.megagameApple = dataDetail // 活动报名
    //   this.organizationUnits = JSON.parse(dataDetail.association) // 组织机构
    //   this.specificfirmElectId = dataDetail.id // 企业id
    //   this.participationCondition = dataDetail.constraints // 参与条件
    //   this.firmElectIntro = dataDetail.introduction // 活动简介
    // },

    // 获取企业相关数据
    async getMegagameData () {
      try {
        const res = await this.$get(this.$url.activity.firmElectSpecificData + this.$route.query.id)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.activeDetailBanner = data.tbAppraise.banner // 大赛横幅
          this.megagameApple = data.tbAppraise // 活动报名
          this.firmElectIntro = data.tbAppraise.introduction // 活动简介
          this.participationCondition = data.tbAppraise.constraints // 参与条件
          this.organizationUnits = JSON.parse(data.tbAppraise.association) // 组织机构
          this.notification = data.innerInfos // 赛事通知
          this.message = data.outerInfos // 相关资讯
          this.activities = data.schedules // 活动安排
          console.log(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.firmElectDetail {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  margin-top: 7px;
  border: 1px solid #f5f5f5;
}
.firmElect-detail {
  width: 1200px;
  min-height: 100vh;
  margin: 10px auto 100px;
  background-color: #f5f5f5;
  display: flex;
  flex-wrap: wrap;
  .page-nav{
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
  }
}
.nav-index{
  width: 985px;
  padding-left: 20px;
  box-sizing: border-box;
  padding: 20px 0 30px 0;
  // margin-top: 20px;
  background-color: #fff;
}
.nav-title{
    display: inline-block;
    box-sizing: border-box;
    padding-left: 20px;
    font-size: 20px;
    font-weight: 600;
    color: #000;
    border-left: 4px solid #3056D9;
    border-radius: 2px 0 0 2px;
}
.firmElect-information{
  width: 207px;
  background-color: #fff;
  margin: -232px 0 0 8px;
  box-sizing: border-box;
  padding: 15px 0;
}
</style>
